module.exports = __webpack_public_path__ + "static/img/news7detail1.88c61df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news7detail1.jpg
// module id = esZM
// module chunks = 0